import { Component, OnInit, Input } from '@angular/core';
import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { GWPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/gw/gw-payment-processor-account-configuration';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'wm-payment-account-config-gw',
  templateUrl: './payment-account-config-gw.component.html',
  // styleUrls: ['./payment-account-config-gw.component.css'],
  standalone: false
})
export class PaymentAccountConfigGWComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {

  @Input() config: GWPaymentProcessorAccountConfiguration;

  constructor(fb: UntypedFormBuilder) {
    super(fb);

    // Carroll County does NOT need username/password
    this.showUsername = false;
    this.showPassword = false;
  }

  // ngOnInit() {
  //   // Required field
  //   this.addValidation('category', Validators.required, this.config.category);
  //   this.addValidation('url', Validators.required, this.config.url);

  //   // Optional fields
  //   this.addValidation('officeCode', null, this.config.officeCode);
  //   this.addValidation('customerCode', null, this.config.customerCode);
  //   this.addValidation('tokenSalt', null, this.config.tokenSalt);
  // }

  ngOnInit() {

  // 🔥 SAFETY (important)
  if (!this.config) {
    this.config = new GWPaymentProcessorAccountConfiguration();
  }

  // Required fields
  this.addValidation('category', Validators.required, this.config.category);
  this.addValidation('url', Validators.required, this.config.url);

  // Optional fields
  this.addValidation('officeCode', null, this.config.officeCode);
  this.addValidation('customerCode', null, this.config.customerCode);
  this.addValidation('tokenSalt', null, this.config.tokenSalt);

  // 🔥 CRITICAL FIX — sync form → config
  this.form.valueChanges.subscribe(values => {
    Object.assign(this.config, values);
  });
}
}